import React from 'react';

class ContractOffer extends React.Component {

  constructor(props) {
    super(props);
  }
  
  render() {

	var a = this;
	var b = a.props.contractOption;

	var hiddenClass = ''

	if (b.Offer === '') {
		hiddenClass = 'd-none'	
	}
	
    return (

		<div className={'col-xs-12 specialOffer ' + hiddenClass}>
			<h6>{b.Offer}</h6>
			<small>with all {b.Name} contracts</small>
		</div>

    );
  }
};

export default ContractOffer;



// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Components/ContractOffer.es6